<template>
    <div
        :class="{
            'app-container g-h-full': true,
            'g-m-auto': !isOnCampaignOrActivation,
            'campaign-activation-container': isOnCampaignOrActivation
        }"
    >
        <router-view />
    </div>
</template>

<script>
    import { computed } from 'vue-demi';
    import useCurrentInstance from '../../../src/helpers/useCurrentInstance';
    export default {
        name: 'AppLayout',

        setup() {
            const instance = useCurrentInstance().$root;

            const isOnCampaignOrActivation = computed(() => {
                if (
                    instance.$route.name.startsWith('v2.campaign') ||
                    instance.$route.name.startsWith('v2.activation') ||
                    instance.$route.name.startsWith('v2.productSelection')
                ) {
                    if (instance.$route.name.endsWith('networks.network')) {
                        return false;
                    }
                    return true;
                }

                return false;
            });

            return {
                isOnCampaignOrActivation
            };
        }
    };
</script>

<style lang="scss" scoped>
    .app-container {
        @media only screen and (min-width: $g-screen-size-xs) {
            width: $g-screen-size-xs;
        }
    }

    .campaign-activation-container {
        max-width: 100% !important;
        width: 100% !important;

        ::v-deep .g-page-layout > .grin-container > :not(.g-header) {
            margin: auto;
            max-width: $g-screen-size-xs;
        }
        ::v-deep .g-page-layout > .g-footer {
            margin: auto;
            max-width: $g-screen-size-xs;
        }
    }
</style>
